import React from 'react'
import PropTypes from 'prop-types'
import i18next from 'i18next'
import {useTranslation} from 'react-i18next'
import {Button} from '@chakra-ui/react'

const UpdatePayeeButton = ({payee, onSelectPayee, width}) => {
  i18next.loadNamespaces('pointsOnPayments')
  const {t} = useTranslation('pointsOnPayments')

  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={() => onSelectPayee(payee)}
      width={width}
    >
      {t('bill.table.callToActions.updatePayee')}
    </Button>
  )
}

UpdatePayeeButton.defaultProps = {
  width: undefined,
}

UpdatePayeeButton.propTypes = {
  payee: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    businessNumber: PropTypes.string,
    bankAccount: PropTypes.shape({
      name: PropTypes.string,
      bsb: PropTypes.string,
      accountNumber: PropTypes.string,
    }),
    lockVersion: PropTypes.number,
  }).isRequired,
  onSelectPayee: PropTypes.func.isRequired,
  width: PropTypes.string,
}

export default UpdatePayeeButton
